<template>
  <div class="user-management">
    <!-- <div class="search-top">
      
    </div>
    <div style="clear: both"></div> -->
    <el-form
      :inline="true"
      :model="listQuery"
      ref="departmentInfo"
      size="small"
      class="search-bar"
    >
      <!-- <el-form-item label="部门" label-width="60px">
        <el-select
          v-model="listQuery.departmentId"
          placeholder="请选择"
          style="width: 150px"
          clearable
        >
          <el-option
            v-for="(item, index) in departmentData"
            :key="index"
            :label="item.departmentName"
            :value="item.departmentId"
          ></el-option>
          
        </el-select>
      </el-form-item> -->
      <div>
        <el-form-item>
          <el-input
            v-model.trim="listQuery.userName"
            placeholder="请输入用户名"
            maxlength="32"
            style="width: 200px"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="listQuery.realName"
            placeholder="真实姓名"
            style="width: 200px"
            maxlength="64"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="listQuery.userPhone"
            placeholder="请输入电话"
            maxlength="11"
            style="width: 200px"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="searchBtn" icon="el-icon-zoom-in">搜索</el-button>
          <el-button size="small" @click="resetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" size="small" @click="goToAdd" icon="el-icon-circle-plus-outline">新增用户</el-button>
      </el-form-item>
    </el-form>
    <el-table
    border 
    :header-cell-style="{ 
      fontWeight: 400,
      background:'#F0F5FC',color:'#333333'}"
    :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="65"> </el-table-column>
      <el-table-column prop="userName" label="用户名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realName" label="真实姓名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="50">
        <template slot-scope="scope">
          <span>{{ scope.row.sex | sexFilters }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="departmentName"
        label="部门名称"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column prop="departmentName" label="所属部门" width="220" show-overflow-tooltip> </el-table-column> -->
      <el-table-column prop="userPhone" label="手机号" width="120"> </el-table-column>
      <!-- departmentName -->
      
      <el-table-column prop="createTime" label="创建时间" width="170">
      </el-table-column>
      <el-table-column prop="lastLogin" label="最后登录" width="170">
      </el-table-column>
      <el-table-column prop="visitNumber" label="访问次数" width="">
      </el-table-column>
      <el-table-column prop="visitNumber" label="状态" width="">
        <!-- 
          <span :class="scope.row.state == 0 ? 'yellowColor' : 'redColor'">{{
            scope.row.state == 0 ? "启用" : "停用"
          }}</span>
        </template> -->
        <template v-slot="scope">
          <div class="states starts" v-if="scope.row.state == 0">
            <img src="@/assets/tableIcon/start.png" class="imgstates" />
            <span class="ml15">启用</span>
          </div>
          <div class="states stops" v-if="scope.row.state == 1">
            <img src="@/assets/tableIcon/stop.png" class="imgstates" />
            <span class="ml15">停用</span>
          </div>
        </template>
        
      </el-table-column>
      <el-table-column label="操作" fixed="right" v-slot="scope" width="270">
        <div class="option-list-box">
          <el-tooltip class="item pointer" effect="dark" content="编辑" placement="top">
            <img src="@/assets/tableIcon/edit.png" @click="goToEdit(scope.row)" />
          </el-tooltip>
          <el-tooltip class="item pointer ml10" effect="dark" content="重置密码" placement="top">
            <img src="@/assets/tableIcon/czmm.png" @click="resetPassword(scope.row)" />
          </el-tooltip>
          <el-tooltip class="item pointer ml10" effect="dark" content="修改密码" placement="top">
            <img src="@/assets/tableIcon/xgmm.png" @click="updataPassword(scope.row)" />
          </el-tooltip>
          <el-tooltip v-if="scope.row.state == 1" class="item pointer ml10" effect="dark" content="启用" placement="top">
            <img src="@/assets/tableIcon/qy.png" @click="statusClick(scope.row)" />
          </el-tooltip>
          <el-tooltip v-if="scope.row.state == 0" class="item pointer ml10" effect="dark" content="停用" placement="top">
            <img src="@/assets/tableIcon/ty.png" @click="statusClick(scope.row)" />
          </el-tooltip>
          <el-tooltip class="item pointer ml10" effect="dark" content="删除" placement="top">
            <img src="@/assets/tableIcon/delete.png" @click="deleteOption(scope.row)" />
          </el-tooltip>
          <!-- <el-link
            :underline="false"
            type="primary"
            @click="goToEdit(scope.row)"
            >编辑</el-link>
          <el-link
            :underline="false"
            type="warning"
            class="ml10r"
            @click="resetPassword(scope.row)"
            >重置密码</el-link>
          <el-link
            :underline="false"
            type="warning"
            class="ml10r"
            @click="updataPassword(scope.row)"
            >修改密码</el-link>
          <el-link
            v-if="scope.row.state == 1"
            :underline="false"
            type="warning"
            class="ml10r"
            @click="statusClick(scope.row)"
            >启用</el-link>
          <el-link
            v-if="scope.row.state == 0"
            :underline="false"
            type="text"
            class="ml10r redColor"
            @click="statusClick(scope.row)"
            >停用</el-link>
          <el-link
            :underline="false"
            type="text"
            class="ml10r redColor"
            @click="deleteOption(scope.row)"
            >删除</el-link> -->
        </div>
      </el-table-column>
    </el-table>
    <div class="page-box mt20r" v-if="total >= 10">
      <el-pagination
        background
        @current-change="getTableList"
        :current-page.sync="listQuery.pageNum"
        :page-size="listQuery.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 编辑用户信息弹窗  -->
    <el-dialog 
    :close-on-click-modal="false"
    :visible.sync="editUserDialogVisible" 
    :show-close="false"
    width="600px">
      <span slot="title" v-if="editType == 'add'">新增用户</span>
      <span slot="title" v-if="editType == 'edit'">编辑用户</span>

      <div class="psword-tips">初始密码为Qaz123!@#</div>
      <editUser
        v-if="editUserDialogVisible"
        :edit-type="editType"
        :edit-user-id="editUserId"
        ref="editUser"
        @success="editSuccessHandel" 
      ></editUser>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditHandle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      width="550px">
      <div v-if="dialogVisible">
        <el-form
          ref="updatePasswordForm"
          :rules="updatePasswordRules"
          :model="updatePasswordForm"
          label-width="120px"
        >
          <el-form-item label="原密码" prop="oldPassword">
            <el-input
              v-model.trim="updatePasswordForm.oldPassword"
              show-password
              clearable
              type="password"
              placeholder="请输入原密码"
              maxlength="50"
              style="width: 270px"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model.trim="updatePasswordForm.password"
              show-password
              clearable
              type="password"
              placeholder="请输入新密码"
              maxlength="50"
              style="width: 270px"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="surePassword">
            <el-input
              v-model.trim="updatePasswordForm.surePassword"
              show-password
              clearable
              type="password"
              placeholder="请输入确认密码"
              maxlength="50"
              style="width: 270px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPassword">取 消</el-button>
        <el-button
          type="primary"
          @click="submitUpdate"
          :disabled="submiting"
          :loading="submiting"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBackstageUserPage,
  DataDelete,
  resetPassword,
  getSysDepartmentList,
} from "@/api/authorityManagement";
import { updatePassword, updateState } from "@/api/login_v2";
import editUser from "./components/editUser.vue";
import { JSEncrypt } from 'jsencrypt'
export default {
  components: {
    editUser,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      // let reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]*$/
    
      let reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{6,}$/;
      if (!reg.test(value)) {
        callback(
          new Error("密码不能少于6位,且必须有数字、大小写字母、特殊字符组合")
        );
      } else {
        callback();
      }
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.updatePasswordForm.surePassword !== "") {
          this.$refs.updatePasswordForm.validateField("surePassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.updatePasswordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      editUserDialogVisible: false,
      submiting: false, //是否正在提交
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        userName: "", //用户名
        userPhone: "", //用户手机
        realName: "", //真实姓名
        //departmentId: "",
      },
      updatePasswordForm: {},
      total: 0,
      tableData: [],
      departmentData: [], //获取部门
      editUserId: "", //编辑的用户ID
      editType: "add", //add 新增，edit 修改
      updatePasswordRules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            min: 6,
            max: 50,
            message: "长度在 6 到 50 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 50,
          //   message: "长度在 6 到 50 个字符",
          //   trigger: "blur",
          // },
          { validator: validatePass, trigger: "blur" },
        ],
        surePassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          {
            min: 6,
            max: 50,
            message: "长度在 6 到 50 个字符",
            trigger: "blur",
          },
          { validator: validatePass2, trigger: "blur" },
        ],
      },

      userId: "",
    };
  },
  mounted() {
    this.getTableList();
    //  this.getDepartmentData();
  },

  filters: {
    sexFilters(val) {
      let result = "--";
      if (val == 0) {
        result = "女";
      }
      if (val == 1) {
        result = "男";
      }
      return result;
    },
  },
  methods: {
    //确定编辑
    confirmEditHandle() {
      this.$refs.editUser.confirmEdit();
    },
    //编辑成功事件
    editSuccessHandel() {
      this.editUserDialogVisible = false;
      this.getTableList();
    },
    // 获取部门
    getDepartmentData() {
      getSysDepartmentList().then((res) => {
        if (res.code == 1) {
          this.departmentData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange() {},
    //列表查询
    getTableList(val) {
      this.listQuery.pages = val;
      this.getTableData();
    },
    getTableData() {
      getBackstageUserPage(this.listQuery).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //搜索按钮
    searchBtn() {
      this.listQuery.pages = 1;
      this.getTableList();
    },
    // 重置
    resetBtn() {
      this.listQuery.keyWord = "";
      this.listQuery.userName = ""; //用户名
      this.listQuery.realName = ""; //真实姓名
      this.listQuery.userPhone = ""; //用户手机
      // this.listQuery.departmentId = "";
      this.getTableData();
    },
    goToAdd() {
      // this.$router.push({
      //   name: "addUser",
      //   query: {
      //     isAdd: 1,
      //   },
      // });

      this.editUserId = "";
      this.editType = "add";
      this.editUserDialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs.editUser.reset();
      // });
    },
    goToEdit(row) {
      // this.$router.push({
      //   name: "editUser",
      //   query: {
      //     userId: row.userId,
      //     isAdd: 2,
      //   },
      // });
      this.editUserId = row.userId;
      this.editType = "edit";
      this.editUserDialogVisible = true;
      // this.$nextTick(() => {
      //   console.log(this.editUserId)
      //   this.$refs.editUser.reset();
      // });
    },

    //删除用户
    deleteOption(row) {
      this.$confirm("确定要删除此用户？", "删除用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            userId: row.userId,
          };
          DataDelete(data).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getTableList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    //重置密码
    resetPassword(row) {
      this.$confirm("确定重置密码为 'Qaz123!@#'？", "重置密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          resetPassword({ userId: row.userId }).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "密码重置成功",
              });
              this.getTableList();
            } else {
              // this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消",
          // });
        });
    },
    updataPassword(row) {
      this.userId = row.userId;
      this.dialogVisible = true;
    },
    cancelPassword() {
      this.updatePasswordForm = {};
      this.dialogVisible = false;
    },
    submitUpdate() {
      this.$refs["updatePasswordForm"].validate((valid) => {
        if (valid) {
          this.submiting = true;

          let submitForm = JSON.parse(JSON.stringify(this.updatePasswordForm))
          let publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCjI6xANKnKoEvoKWxfTdWv+5GlK4fi9b/R4Tejb2Yh2ifASO3m6vu0NIMlYQbAdYu23u/qZ0n2aygQhMgWfXm2B+FH7meA1zVz2OygzCEKjw9K+HbEtfhqoDyiQVdHL9zTrRsZAzXhe98DwyR12qMhTQ1GDUsxTXXSgelh4uv/QQIDAQAB";
          let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
          encryptor.setPublicKey(publicKey); // 设置公钥
          
          submitForm.oldPassword = encryptor.encrypt(this.updatePasswordForm.oldPassword);
          submitForm.password = encryptor.encrypt(this.updatePasswordForm.password);
          submitForm.surePassword = encryptor.encrypt(this.updatePasswordForm.surePassword);
          updatePassword({ ...submitForm, userId: this.userId })
            .then((res) => {
              // console.log("****")
              // console.log(res);
              this.submiting = false;
              if (res.code == 1) {
                this.$message.success("密码修改成功！");
                this.updatePasswordForm = {};
                this.dialogVisible = false;
                this.getTableData();
              } else {
                // this.$message.error(res.msg);
              }
            })
            .catch((e) => {
              this.submiting = false;
              this.ruleForm.verification = "";
            });
        } else {
          return false;
        }
      });
    },
    // 停用/启用
    statusClick(row) {
      this.$confirm(
        `确定要 ${row.state == 1 ? "启用" : "停用"} 此用户？`,
        `${row.state == 1 ? "启用" : "停用"}用户`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let state = null;
          if (row.state == 0) {
            state = 1;
          } else {
            state = 0;
          }
          let data = {
            userId: row.userId,
            state: state,
          };
          updateState(data).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.getTableList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.user-management {
  .search-top {
    height: 40px;
    float: right;
  }

  .search-bar {
    display: flex;
    justify-content: space-between;
  }
  .option-list-box {
    display: flex;
    span {
      cursor: pointer;
    }
  }
  .page-box {
    text-align: right;
  }
  .ml10r {
    margin-left: 10px;
  }
}
.starts {
  background: #D6F7F1;
  color: #11D6A1;
}
.stops {
  background: #FFEEE1;
  color: #FF9446;
}
.states {
  width: 72px;
  height: 34px;
  border-radius: 17px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  
  text-align: center;
  line-height: 34px;
}
.imgstates {
  position: absolute;
  left: 22px;
  top: 21px;
}
.psword-tips {
  position: absolute;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFA564;
  top: 21px;
  right: 20px;
}
</style>
